export const EDITOR_URI = '/eval-editor'
export const LIST_URI = '/eval-list'
export const ANSWERS_URI = '/eval-answers'
export const FILL_URI = '/eval-fill'
export const TEAMS_URI = '/teams'
export const RESULTS_URI = '/results'
export const CHANGELOG_URI = '/changelog'
export const EMPLOYEE_DETAILS_URI = '/employee-details'